export default {
  OFFICE_COMPATIBLES: [
    'doc',
    'docx',
    'dot',
    'dotx',
    'odt',
    'ott',
    'rtf',
    'txt',
    'xls',
    'xlsx',
    'xlt',
    'xltx',
    'ods',
    'ots',
    'csv',
    'ppt',
    'pptx',
    'pot',
    'potx',
    'odp',
    'otp',
    'odg',
    'otg',
    'html',
    'htm',
    'xml',
  ]
};
